import { ChargePointIsOnline } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-is-online.enum';
import { useTranslation } from 'react-i18next';

import { BooleanTriStateFilterController } from '@shared/filter/boolean-tri-state-filter/boolean-tri-state-filter.controller';

interface ChargePointIsOnlineFilterControllerProps {
  // null (not undefined) represents "All" — react-hook-form's Controller
  // falls back to its mount-time default whenever the live value is
  // undefined, so an explicit clear must never be undefined.
  onChange: (value: boolean | null) => void;
  selectedItem?: boolean | null;
}

const backgroundColorByState: Record<ChargePointIsOnline, string> = {
  [ChargePointIsOnline.TRUE]: 'bg-surface-success',
  [ChargePointIsOnline.FALSE]: 'bg-surface-error',
  [ChargePointIsOnline.ALL]: 'bg-surface-brand-secondary',
};

export const ChargePointIsOnlineFilterController = ({
  onChange,
  selectedItem,
}: ChargePointIsOnlineFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const options = Object.values(ChargePointIsOnline).map((state) => ({
    key: state,
    label: t(`delmonicos-shared-sdk.outputs-charge-point-is-online.${state}`),
    value:
      state === ChargePointIsOnline.TRUE
        ? true
        : state === ChargePointIsOnline.FALSE
          ? false
          : null,
    colorClassName: backgroundColorByState[state],
  }));

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <BooleanTriStateFilterController
      iconName="wifi"
      text={t('delmonicos-shared-sdk.outputs-charge-point.is-online')}
      options={options}
      selectedItem={selectedItem}
      onChange={onChange}
    />
  );
};
